import {Injectable} from '@angular/core';
import {MxEnvironmentService} from 'mx-core';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PrlEnvironmentService implements MxEnvironmentService {
    getEnvironmentVariable(variable: string): string | boolean | number {
      return environment[variable];
    }
}
